import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";


import { Http, Headers } from '@angular/http';

@Component({
  selector: 'app-detail-dialog',
  templateUrl: './detail-dialog.component.html',
  styleUrls: ['./detail-dialog.component.scss']
})
export class DetailDialogComponent implements OnInit {
  product: any;
  sub: any;
  isEdit = false;
  constructor(
    public dialogRef: MatDialogRef<DetailDialogComponent>,
    private http: Http,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.product = data;

  }

  ngOnInit() {
  }
  changeText(string) {
    return string
      .trim()
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u')
      .replace('&', 've')
      .replace(/,/g, '')
      .replace(/\./g, '_')
      .replace(/\-/g, '')
      .replace(/\'/g, '')
      .replace(/\s/g, '')
      .toLowerCase();
  }

  editName(text) {

  }



  closeDialog(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/suggestions/detail-dialog/detail-dialog.component.ts